import { http } from 'src/services/auth/http'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IGetBillingStatParams {}

export interface IBillingMetric {
  key: string
  type: string
  unit: string
  used: number
  included: number
  unitPrice: number | null
  currency: string | null
  billableOverage: number | null
  amount: number | null
  capturedAt?: string
}
export interface IGetBillingStatData {
  currency: string
  metrics: IBillingMetric[]
  period: { start: string; end: string; timezone: string }
  totalAmount: number
}

export const getBillingStat = (parmas?: IGetBillingStatParams) =>
  http.get<IGetBillingStatData[]>('/partner/billing-stat', parmas)

export const getPartnerCheck = () => http.get('/partner-check')
